import React from 'react'
import styled from 'styled-components'
import PropTypes  from 'prop-types';


const StyledContainer = styled.div`
  background: white;
  box-shadow: 0 1px 4px rgba(0,0,0,.15);
  height: 100px;
  padding: 5px;
  cursor:pointer;
`

const Title = styled.div`
  padding-top: 10px;
  color: black;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  margin:auto;
  height:45px;
  @media (max-width: 500px) {
    font-size: 1rem;
  }
`

const Count = styled.h4`
  color: white;
  font-weight: 300;
  margin: 10px;
  padding: 5px;
  background: grey;
  text-align: center;
  cursor:pointer;
  @media (max-width: 500px) {
    font-size: 0.8rem;
  }
`

// const Action = styled.button`
//   color: white;
//   background: #4daa0b;
//   display: block;
//   margin: auto;
//   width: 50%;
//   :hover {
//     opacity: 0.8;
//   }
//   @media (max-width: 500px) {
//       width: 60%;
//       margin-bottom: 4px;
//       font-size: 0.65rem;
//     }
//   `


const Card = ({
  title,
  count,
  action,
  onClick,
  clicked,
  style
}) => {
  return(
  <StyledContainer onClick={onClick} style={clicked ? {opacity:'0.6'}:{opacity:'1'}}>
    <Title>{title}</Title>
    {count ?
      <Count style={{backgroundColor:style}}>{count}</Count>
      :
      <div />
    }
  </StyledContainer>
);
};

Card.propTypes = {
  onClick:  PropTypes.func
};





export default Card;



// WEBPACK FOOTER //
// ./src/app/components/card/Card.js